"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var operators_1 = require("rxjs/operators");
var Observable_1 = require("rxjs/Observable");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var Subject_1 = require("rxjs/Subject");
var custom_calculation_service_1 = require("../../shared/services/api/custom-calculation.service");
var related_entity_1 = require("./model/related-entity");
var related_entity_settings_component_1 = require("./settings/related-entity-settings.component");
var related_entity_service_1 = require("./service/related-entity.service");
var idm_dynamic_forms_ui_1 = require("@synisys/idm-dynamic-forms-ui");
var form_resolution_service_1 = require("../../shared/services/api/form-resolution.service");
var RelatedEntityComponent = /** @class */ (function () {
    function RelatedEntityComponent(relatedEntityService, customCalculationService, formResolutionService, kbService) {
        this.relatedEntityService = relatedEntityService;
        this.customCalculationService = customCalculationService;
        this.formResolutionService = formResolutionService;
        this.kbService = kbService;
        this._relatedEntities = [];
        this._destroy$ = new Subject_1.Subject();
    }
    Object.defineProperty(RelatedEntityComponent.prototype, "relatedEntities", {
        get: function () {
            return this._relatedEntities;
        },
        enumerable: true,
        configurable: true
    });
    RelatedEntityComponent.prototype.ngOnInit = function () {
        if (this.entity) {
            this.loadRelatedEntities(false);
            this.initActionNotifier();
        }
    };
    RelatedEntityComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    RelatedEntityComponent.prototype.loadRelatedEntities = function (nocache) {
        var _this = this;
        if (this.entity.getInstanceId()) {
            var relatedCategories = this.relatedEntityConfigs.map(function (value) { return value.metaCategory['metaCategoryId']['systemName']; });
            this.relatedEntityService.getRelatedEntitiesByInstanceId(this.category, this.entity.getInstanceId(), relatedCategories, nocache)
                .pipe(operators_1.map(function (derivatives) {
                return _this.relatedEntityConfigs
                    .filter(function (value) { return derivatives[value.metaCategory['metaCategoryId']['systemName']]; })
                    .map(function (value) {
                    var category = value.metaCategory['metaCategoryId']['systemName'];
                    var standardColumns = value.columns.filter(function (column) { return !column.isCustom; }).map(function (column) { return column.key; });
                    var customColumns = value.columns.filter(function (column) { return column.isCustom; });
                    return new related_entity_1.RelatedEntity(category, _this.constructFilter(category, derivatives), standardColumns, customColumns, value.showNavigationButton, value.title);
                });
            }), operators_1.takeUntil(this._destroy$))
                .subscribe(function (data) {
                _this._relatedEntities = data;
            });
        }
    };
    RelatedEntityComponent.prototype.loadCustomValue = function (category1, instance1, category2, data2, key) {
        return this.customCalculationService.calculate(key, category1, instance1, this.entity, category2, data2.id, data2);
    };
    RelatedEntityComponent.prototype.changeCategoryItems = function (tableData, tableCategory, customColumns) {
        var _this = this;
        tableData.portfolioItems.forEach(function (portfolioItem) {
            portfolioItem.valueOfColumn.set('_ccd', new Map());
            customColumns.forEach(function (cc) {
                var customColumnValue$ = _this.loadCustomValue(_this.category, _this.entity.getInstanceId(), tableCategory, portfolioItem.entitySearchItem, cc.key);
                portfolioItem.valueOfColumn.get('_ccd').set(cc.key, customColumnValue$);
            });
        });
    };
    RelatedEntityComponent.prototype.onEntityClick = function (data) {
        if (this.form.actions.isViewForm()) {
            this.form.actions.editEntityPopup(data.formProperties.viewFormName, data.category, data.formProperties.viewFormId, data.entityId);
        }
        else {
            this.form.actions.editEntityPopup(data.formProperties.editFormName, data.category, data.formProperties.editFormId, data.entityId);
        }
    };
    RelatedEntityComponent.prototype.onNavigationBtnClick = function (category, portfolioItem) {
        var _this = this;
        this.formResolutionService.getEntityFormProperties(category, portfolioItem.entityInstanceId, portfolioItem.entitySearchItem)
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (formProperties) {
            if (_this.form.actions.isViewForm()) {
                _this.form.actions.editEntityPopup(formProperties.editFormName, category, formProperties.editFormId, portfolioItem.entityInstanceId);
            }
            else {
                _this.form.actions.editEntityPopup(formProperties.viewFormName, category, formProperties.viewFormId, portfolioItem.entityInstanceId);
            }
        });
    };
    RelatedEntityComponent.prototype.constructFilter = function (category, derivatives) {
        return this.kbService.getInstanceMetaField(category).pipe(operators_1.map(function (instanceMetaField) {
            return new idm_de_core_frontend_1.FilterBuilder().in(instanceMetaField.getSystemName(), derivatives[category]).build();
        }));
    };
    RelatedEntityComponent.prototype.initActionNotifier = function () {
        var _this = this;
        if (this.actionNotifier) {
            this.actionNotifier
                .pipe(operators_1.debounceTime(500), operators_1.takeUntil(this._destroy$))
                .subscribe(function (eventData) {
                if (_this.isActionDrawerSave(eventData)) {
                    _this.loadRelatedEntities(true);
                }
            });
        }
    };
    RelatedEntityComponent.prototype.isActionDrawerSave = function (saveEventData) {
        var serviceResponse = saveEventData && saveEventData.data;
        return saveEventData.key === idm_dynamic_forms_ui_1.ActionNotifierKey.DRAWER_SAVE_ACTION && serviceResponse
            && serviceResponse.getMeta()
            && serviceResponse.getMeta().getValidationErrors().length === 0;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_service_client_js_1.MainEntity)
    ], RelatedEntityComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], RelatedEntityComponent.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], RelatedEntityComponent.prototype, "form", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], RelatedEntityComponent.prototype, "isView", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Observable_1.Observable)
    ], RelatedEntityComponent.prototype, "actionNotifier", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], RelatedEntityComponent.prototype, "relatedEntityConfigs", void 0);
    RelatedEntityComponent = __decorate([
        core_1.Component({
            
            selector: 'ejustice-related-entity',
            styles: [require('./related-entity.component.css')],
            template: require('./related-entity.component.html')
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            name: 'Related Entity',
            cellCount: 12,
            settings: {
                main: related_entity_settings_component_1.RelatedEntitySettingsComponent,
            },
            template: "<ejustice-related-entity\n                [entity]=\"entity\"\n                [category]=\"category\"\n                [form]=\"form\"\n                [isView]=\"actions.isViewForm()\"\n                [actionNotifier]=\"actionNotifier\"\n                [relatedEntityConfigs]=\"%{relatedEntityConfigs}\">\n             </ejustice-related-entity>"
        }),
        __metadata("design:paramtypes", [related_entity_service_1.RelatedEntityService,
            custom_calculation_service_1.CustomCalculationService,
            form_resolution_service_1.FormResolutionService,
            idm_kb_service_client_js_1.KbService])
    ], RelatedEntityComponent);
    return RelatedEntityComponent;
}());
exports.RelatedEntityComponent = RelatedEntityComponent;
//# sourceMappingURL=related-entity.component.js.map